// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"364":"bf871406","446":"2caa3cad","663":"f5037e77","848":"0a892e45"}[chunkId] + ".css";
};